import { createFileRoute, Outlet } from '@tanstack/react-router'

/**
 * Articles layout route for Creation module
 */
export const Route = createFileRoute('/_app/creation/articles')({
  component: () => <Outlet />,
})
